import React from 'react';
import cx from 'classnames';
import { PlanCard } from '~/types/models/plasmic';

export interface BadgeBarProps extends Pick<PlanCard, 'badge'> {}

export function BadgeBar({ badge }: BadgeBarProps) {
  return (
    <span
      className={cx([
        'flex items-center justify-center',
        'rounded-t-md font-bold text-xs h-[30px]',
      ])}
      style={{
        color: badge?.textColor,
        backgroundColor: badge?.bgColor,
      }}
    >
      {badge?.label}
    </span>
  );
}
